<template>
  <div>
     <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>          
          <v-container grid-list-md>
            <v-layout wrap>     
              
            <div style="overflow: auto; white-space: nowrap;">
              <table class="reportTbl" width="100%">
                <tbody>
                
                  <tr class="textCenter textBold">
                    <th rowspan="1">Financial Year</th>
                    <th colspan="2">
                      <v-autocomplete
                        item-text="financial_year"
                        item-value="id"                 
                        v-model="formSchema.years_1"
                        :items="BudgetingYearList"
                        :rules="[v => !!v || 'Financial year is required !']"
                        required
                        @input="fiYearChange(formSchema.years_1)"
                      ></v-autocomplete>
                    </th>
                    <th colspan="3">
                      <v-autocomplete
                        item-text="financial_year"
                        item-value="id"              
                        v-model="formSchema.years_2"
                        :items="BudgetingYearList"
                        :rules="[v => !!v || 'Financial year is required !']"
                        readonly
                      ></v-autocomplete>
                    </th>
                  </tr>
                  <tr class="textCenter textBold">
                    <th rowspan="2">Category</th>
                    <th colspan="2">
                      <v-autocomplete
                      item-text="quarter_name"
                        item-value="id"                
                        v-model="formSchema.quarter_1"
                        :items="QuarterList"
                        :rules="[v => !!v || 'Financial year is required !']"
                        required
                        @input="quaterChange(formSchema.quarter_1)"
                      ></v-autocomplete>
                    </th>
                    <th colspan="2">
                      <v-autocomplete
                        item-text="quarter_name"
                        item-value="id"                
                        v-model="formSchema.quarter_2"
                        :items="QuarterList"
                        :rules="[v => !!v || 'Financial year is required !']"
                        readonly
                      ></v-autocomplete>
                    </th>
                  </tr>
                  <tr class="textCenter textBold">
                    <th>Credit A</th>
                    <th>Credit B</th>
                    <th>Credit A</th>
                    <th>Credit B</th>
                  </tr>
                  <tr class="textCenter textBold">
                    <td>                      
                      TA
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[0].q1_creditA" :rules="[decimalShort,v => !!v || 'Field is required !']" @input="SumValues('q1_creditA','Q1_total_A')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[0].q1_creditB" :rules="[decimalShort,v => !!v || 'Field is required !']" required @input="SumValues('q1_creditB','Q1_total_B')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[0].q2_creditA" :rules="[decimalShort,v => !!v || 'Field is required !']" required @input="SumValues('q2_creditA','Q2_total_A')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[0].q2_creditB" :rules="[decimalShort,v => !!v || 'Field is required !']" required @input="SumValues('q2_creditB','Q2_total_B')"></v-text-field>
                    </td>

                  </tr>

                  <tr class="textCenter textBold">
                    <td>                      
                      Onlending
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[1].q1_creditA"
                      :rules="[decimalShort,v => !!v || 'Field is required !']" @input="SumValues('q1_creditA','Q1_total_A')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[1].q1_creditB" :rules="[decimalShort,v => !!v || 'Field is required !']" @input="SumValues('q1_creditB','Q1_total_B')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[1].q2_creditA" :rules="[decimalShort,v => !!v || 'Field is required !']" @input="SumValues('q2_creditA','Q2_total_A')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[1].q2_creditB" :rules="[decimalShort,v => !!v || 'Field is required !']" @input="SumValues('q2_creditB','Q2_total_B')"></v-text-field>
                    </td>
                  </tr>

                  <tr class="textCenter textBold">
                    <td>Total</td>
                    <td><v-text-field v-model="formSchema.Q1_total_A" readonly hide-details></v-text-field></td>
                    <td><v-text-field v-model="formSchema.Q1_total_B" readonly hide-details></v-text-field></td>
                    <td><v-text-field v-model="formSchema.Q2_total_A" readonly hide-details></v-text-field></td>
                    <td><v-text-field v-model="formSchema.Q2_total_B" readonly hide-details></v-text-field></td>
                  </tr>
                  <tr class="textCenter textBold">
                  <td colspan="3"> Is Active </td>
                  <td colspan="2">
                    <v-flex xs12 sm6 md4 >
                      <v-checkbox v-model="formSchema.is_active" label="Active" :value="is_activeVal"></v-checkbox>
                    </v-flex>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="$refs.form.reset" @click="resetForm">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->



  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
let utilities = require("../../../utilities/utilities");
import DatePicker from "../../global/date_picker";

export default {
  props: ["formSchema"],
  components: {
    DatePicker
  },
  data: () => ({
    valid: true,
    is_activeVal:1,
    BudgetingYearList: [],
    QuarterList:[],

    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? "Edit Project Cash Statement" : "Add Project Cash Statement";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },

  created() {
    commonService.getAllData("forecast_pre_Data").then(res => {
      if (res.status == "success") {
        this.BudgetingYearList = res.year;
        this.QuarterList = res.quarter;
      }
    });    
  },

  methods: {

    SumValues(fieldName,totalFiel)
    {
      let A = this.formSchema.quater[0][fieldName];
      let B = this.formSchema.quater[1][fieldName];
      let Total = this.formSchema[totalFiel] = ((parseFloat(A) || 0) + (parseFloat(B)||0)).toFixed(3);
    },

    fiYearChange(a){
      this.formSchema.years_2 = a
    },
    quaterChange(a){
      if(a==4){
        this.formSchema.years_2 = (this.formSchema.years_2 +1);
        this.formSchema.quarter_2 = (a - 3);
      }else{
        this.formSchema.years_2 = this.formSchema.years_1
        this.formSchema.quarter_2 = (a+1);
      }
      
    },

    validateBeforeSubmit(e) {

      var formSchema = this.formSchema;
      if (this.$refs.form.validate()) {
        let formData = new FormData();
        formData.append("fieldValues", JSON.stringify(formSchema));
        commonService.insertFormData(formData, "pro_forecast_inset").then(res => {
          let actionData = {
            message: res.message,
            data: res.data,
            action: res.action,
            status: res.status
          };

          if (res.status == 1) {
            this.$refs.form.reset();
            this.formSchema.id = 0;
            this.formSchema.start_date = ''
            this.formSchema.end_date = ''
          }
          this.close(actionData);
        });
      }
    },
    
    resetForm(){
      this.formSchema.id = 0;      
    },

    close: function(data) {      
      this.$emit("emitForm", data);
    }
  }
};
</script>
<style scoped>
  table.reportTbl{
    border-collapse: collapse;
  }
  .reportTbl th{
    line-height: 30px;
  }
  .reportTbl th,
  .reportTbl tr td{
    border:1px solid #CCC !important;  
  }
  .reportTbl tr.textCenter,
  .textCenter
  {
    text-align: center;
  }
  .reportTbl tr.textBold,
  .textBold{
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// src/components/project_info/project_forcust_report/dataForm.vue